export const criticReviews = [
  {
    id: 1,
    quote: "Deeply engaging exploration of human connection... emotional authenticity woven into every interaction.",
    reviewer: "Margaret E.",
    title: "Senior Critic",
    experience: "14 Years Experience"
  },
  {
    id: 2,
    quote: "Beautifully written... captures the complexities of growth. A refreshing and sincere read.",
    reviewer: "Thomas A.",
    title: "Book Analyst",
    experience: "12 Years Experience"
  },
  {
    id: 3,
    quote: "Feels intimate and relatable, as if sharing lived experiences rather than fiction.",
    reviewer: "Lila F.",
    title: "Literary Reviewer",
    experience: "11 Years Experience"
  },
  {
    id: 4,
    quote: "Captures the nuances of friendship in a way that feels contemporary and timeless.",
    reviewer: "Daniel B.",
    title: "Senior Reviewer",
    experience: "15 Years Experience"
  },
  {
    id: 5,
    quote: "An addictive, emotionally rich story... five stars without hesitation.",
    reviewer: "Javier M.",
    title: "Global Readers Forum",
    experience: "12 Years Experience"
  },
  {
    id: 6,
    quote: "Filled with warmth, honesty, and emotional clarity... A powerful reminder of the importance of meaningful connections.",
    reviewer: "Priya N.",
    title: "Book Critic",
    experience: "13 Years Experience"
  },
  {
    id: 7,
    quote: "A refreshing perspective that feels both modern and deeply human... A rewarding read from beginning to end.",
    reviewer: "Gregory H.",
    title: "Literary Reviewer",
    experience: "10+ Years Experience"
  },
  {
    id: 8,
    quote: "An exceptional work that blends emotional depth with accessible storytelling... resonates on multiple levels.",
    reviewer: "Eleanor W.",
    title: "Senior Literary Analyst",
    experience: "16 Years Experience"
  },
  {
    id: 9,
    quote: "Engaging and deeply moving... captures the essence of connection in a way that feels authentic and relatable.",
    reviewer: "Samuel R.",
    title: "Senior Reviewer",
    experience: "14 Years Experience"
  }
];

export const amazonReviews = [
  {
    id: 'a1',
    reviewer: "Amazon Customer",
    title: "Nothing can derail the Peace Train!",
    date: "April 3, 2018",
    quote: "Some — perhaps most — might call Sara Salinger naive and the permanent wearer of rose-colored glasses. After attending a summer camp in the U.S. that brings together Israeli and Palestinian youths, she returns to her homeland convinced that peace can prevail in the region if more people committed to seeing and hearing one another deeply. Not even a shattering personal tragedy can deflect her from this path. Renée Mollan-Masters will make a believer out of you.",
    country: "United States"
  },
  {
    id: 'a2',
    reviewer: "Mike Kaleikini",
    title: "Can't. Put. Down.",
    date: "February 17, 2018",
    quote: "The struggle of love and hate is so well portrayed in this book. To see what these two cultures are going through daily and the change that a new generation are trying to make is simply awesome. I'm not an emotional person but I could not help but tear up numerous times in this book. The wording is so well thought out, you can't help but feel what the author is trying to show.",
    country: "United States"
  },
  {
    id: 'a3',
    reviewer: "Ellen Craine",
    title: "A moving and powerful story!",
    date: "February 26, 2018",
    quote: "This book offers hope for the world—that peace can be built, one relationship at a time, when we truly listen to understand one another. Although the story revolves around the Israeli-Palestinian divide, the ideas can be used in our communities and families as well. I found the story very moving and the characters engaging.",
    country: "United States"
  },
  {
    id: 'a4',
    reviewer: "Kim Terry Schwarz",
    title: "Wow. Just WOW!",
    date: "February 13, 2018",
    quote: "If you want a book with substance, something to pile up and become engrossed with, this is the book for you. The fact that it's a love story, too, not just between a boy and a girl but, also, between cultures who typically grow up hating each other, this is the book for you! Well done, Renee Mollan-Masters!",
    country: "United States"
  },
  {
    id: 'a5',
    reviewer: "Kindle Customer",
    title: "Loved all the characters and the beautiful picture of forgiveness",
    date: "March 1, 2018",
    quote: "Just finished reading Peace Train. Very powerful message of the potential we have to make peace if we build bridges by getting to know people instead of walls that divide because of prejudice, traditions, generations of hatred. Loved all the characters and the beautiful picture of forgiveness and healing. Great book!",
    country: "United States"
  },
  {
    id: 'a6',
    reviewer: "Dulce Delgado",
    title: "In love....",
    date: "April 3, 2018",
    quote: "As a student, I don't usually have time to read. However this one really caught my attention and after reading it, I shall recommend this to you. Beautiful narration, amazing plot and a great way to start your day with a nice book! I loved it.",
    country: "United States"
  },
  {
    id: 'a7',
    reviewer: "Life Changer",
    title: "5 Star Novel on Amazon",
    date: "April 2, 2018",
    quote: "This book was a great read. It had me glued to each and every line. This author made me feel every emotion in this novel, will definitely tell others to buy this book.",
    country: "United States"
  },
  {
    id: 'a8',
    reviewer: "Kathie E. England",
    title: "We need this perspective everywhere!",
    date: "August 14, 2018",
    quote: "Let us believe in the possibility of NO MORE! If not now, when? Can we dare to respond differently? Thank you, Renee!",
    country: "United States"
  },
  {
    id: 'a9',
    reviewer: "Paul Periera",
    title: "Amazing. Everyone should read this awesome book",
    date: "April 2, 2018",
    quote: "Amazing. Everyone should read this awesome book. Loved all the characters and the beautiful picture of forgiveness and healing. Great book written. Insightful look into foster care told from the heart. With some good lessons and actionable tasks including self-reflection and note taking.",
    country: "India"
  }
];

// Unified Array linking types for dynamic rendering
export const allReviews = [
  ...criticReviews.map(r => ({ ...r, type: 'critic' })),
  ...amazonReviews.map(r => ({ ...r, type: 'amazon' }))
];